import { render, staticRenderFns } from "./OdooMostrador.vue?vue&type=template&id=d4f20164"
import script from "./OdooMostrador.vue?vue&type=script&lang=js"
export * from "./OdooMostrador.vue?vue&type=script&lang=js"
import style0 from "./OdooMostrador.vue?vue&type=style&index=0&id=d4f20164&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports